// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__uPADo","content":"ManualTimeModal_content__2OQ6-"};